import { render, staticRenderFns } from "./HotelOptionInfo.vue?vue&type=template&id=8abb2c22&scoped=true"
import script from "./HotelOptionInfo.vue?vue&type=script&lang=js"
export * from "./HotelOptionInfo.vue?vue&type=script&lang=js"
import style0 from "./HotelOptionInfo.vue?vue&type=style&index=0&id=8abb2c22&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8abb2c22",
  null
  
)

export default component.exports